import { Tabs } from '@mui/material';

import { ThemeMarker } from '../CustomerTriggeredEventsPage.styled';
import { StyledChannelTab } from './ChannelTabs.styled';
import { IChannelType } from './ScreenConfigSection.interface';

export const ChannelTabs = ({
  channelTypes,
  selectedTab,
  setSelectedTab,
}: {
  channelTypes: IChannelType[];
  selectedTab: string;
  setSelectedTab: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <Tabs
      value={selectedTab}
      onChange={(_e, label) => setSelectedTab(label)}
      textColor="secondary"
      sx={{ marginBottom: 2 }}>
      {channelTypes.map((channelType) => (
        <StyledChannelTab
          key={channelType.label}
          iconPosition="start"
          icon={
            <>
              {Array.from({ length: channelType.screenNumber }).map(
                (_, index) => (
                  <ThemeMarker
                    key={index}
                    style={{
                      backgroundColor:
                        selectedTab === channelType.label
                          ? 'rgba(0, 0, 0, 0.56)'
                          : 'rgba(0, 0, 0, 0.12)',
                      marginRight:
                        index === channelType.screenNumber - 1 ? '10px' : '2px',
                    }}
                    height="16px"
                  />
                ),
              )}
            </>
          }
          label={channelType.label}
          value={channelType.label}
        />
      ))}
    </Tabs>
  );
};
